export default __webpack_public_path__ + "static/26-1af7e963a003ee58c3864a3ad2434413.jpg";